import { render, staticRenderFns } from "./CompRankingTabs.vue?vue&type=template&id=36559a9e&scoped=true"
import script from "./CompRankingTabs.vue?vue&type=script&lang=js"
export * from "./CompRankingTabs.vue?vue&type=script&lang=js"
import style0 from "./CompRankingTabs.vue?vue&type=style&index=0&id=36559a9e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36559a9e",
  null
  
)

export default component.exports